import { render } from "./FillMenuComp.vue?vue&type=template&id=01851fdd&scoped=true"
import script from "./FillMenuComp.vue?vue&type=script&lang=js"
export * from "./FillMenuComp.vue?vue&type=script&lang=js"

import "./FillMenuComp.vue?vue&type=style&index=0&id=01851fdd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01851fdd"]])

export default __exports__